<script>
  export let data;
  let result = 4;
</script>

<div class="input-rating">
  <h3>
    {#if data.required}
      <strong>*</strong>
    {/if}
    {data.placeholder}
  </h3>
  <fieldset>
    {#each new Array(5).fill() as _, i}
      <label data-selected={result > i}>
        <input checked={i === result} on:click={() => (result = i + 1)} value={i + 1} name={data.key} type="radio" />
      </label>
    {/each}
  </fieldset>
</div>

<style>
  fieldset,
  div {
    display: inline-flex;
    align-items: center;
  }

  input {
    display: none;
  }

  label {
    width: 32px;
    height: 32px;
    background-position: center center;
    background-size: contain;
    cursor: pointer;
  }

  label[data-selected='true'] {
    background-image: url('https://admin.uberi.pro/uploads/star_7137f7de2b.svg');
  }

  label[data-selected='false'] {
    background-image: url('https://admin.uberi.pro/uploads/star_3e7a6d378e.svg');
  }

  fieldset {
    gap: 5px;
  }

  div {
    flex-wrap: wrap;
    gap: 20px;
  }

  h3 {
    position: relative;
    padding-left: 10px;
    color: rgb(44 51 60 / 35%);
    font-weight: 600;
    font-size: 16px;
    font-family: Vela Sans;
    font-style: normal;
    white-space: nowrap;
  }

  strong {
    color: rgb(255 99 71);
  }
</style>
